/* eslint-disable */
// @ts-nocheck
/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/no-unknown-property */
/* eslint-disable prefer-template */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/no-unresolved */
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars, react/jsx-newline, react/jsx-no-bind, no-else-return */
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps, @typescript-eslint/no-use-before-define, no-lonely-if, no-nested-ternary, import/no-extraneous-dependencies */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-newline */
/* eslint-disable react/button-has-type */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react';
import { Button, message } from 'antd';
import { PrinterOutlined, DownloadOutlined, FileTextOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import html2pdf from 'html2pdf.js';
import { generateSettlementPDF } from '../../utils/pdfGenerator';
import { generateSettlementTextPDF } from '../../utils/pdfGeneratorItsTextCanCopied';
import './PDFPreview.css';

const PDFPreview = () => {
  const intl = useIntl();
  const [settlementData, setSettlementData] = useState(null);
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    console.log('PDFPreview component mounted');

    // Get settlement data from URL parameters or sessionStorage
    const urlParams = new URLSearchParams(window.location.search);
    const dataParam = urlParams.get('data');

    if (dataParam) {
      try {
        const data = JSON.parse(decodeURIComponent(dataParam));
        console.log('Settlement data from URL:', data);
        setSettlementData(data);
      } catch (error) {
        console.error('Error parsing settlement data:', error);
        message.error('Failed to load settlement data');
      }
    } else {
      // Fallback to sessionStorage
      const storedData = sessionStorage.getItem('settlementPDFData');
      console.log('Stored data from sessionStorage:', storedData);

      if (storedData) {
        try {
          const data = JSON.parse(storedData);
          console.log('Parsed settlement data:', data);
          setSettlementData(data);
          console.log('Settlement data loaded successfully');
        } catch (error) {
          console.error('Error parsing stored settlement data:', error);
          message.error('Failed to load settlement data');
        }
      } else {
        console.log('No settlement data found in sessionStorage');
        message.error('No settlement data found');
      }
    }
  }, []);

  // Regenerate HTML content when settlement data or intl changes (language change)
  useEffect(() => {
    if (settlementData) {
      generateHTMLContent(settlementData);
    }
  }, [settlementData, intl]);


  const generateHTMLContent = (data) => {
    console.log('Generating HTML content for settlement data:', data);

    // Helper function to format dates as dd-mm-yyyy
    const formatDate = (dateString) => {

      if (!dateString) return '-';

      let date;
      // Handle different date formats
      if (typeof dateString === 'string') {
        // If it's an ISO string or standard format, use it directly
        if (dateString.includes('T') || dateString.includes('-')) {
          date = new Date(dateString);

        } else {
          // If it's in MM/DD/YYYY format, convert to proper format
          const parts = dateString.split('/');
          if (parts.length === 3) {

            // Assume MM/DD/YYYY and convert to YYYY-MM-DD
            date = new Date(`${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`);
          } else {
            date = new Date(dateString);
          }
        }
      } else {
        date = new Date(dateString);
      }
      //alert(date);
      // Check if the date is valid
      if (isNaN(date.getTime())) return '-';

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    // Helper function to translate status values
    const getTranslatedStatus = (status) => {
      const statusTranslations = {
        'Draft': intl.formatMessage({ id: 'settlement_StatusDraft' }),
        'Confirmed': intl.formatMessage({ id: 'settlement_StatusConfirmed' }),
        'Cleared': intl.formatMessage({ id: 'settlement_StatusCleared' }),
        'Reversed': intl.formatMessage({ id: 'settlement_StatusReversed' })
      };
      return statusTranslations[status] || status;
    };

    // Helper function to format financial values
    const formatAmount5 = (value) => {
      return Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 5, maximumFractionDigits: 5 });
    };
    const formatAmount2 = (value) => {
      return Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    // Define getAccountName function inside generateHTMLContent to ensure it uses current intl context
    const getAccountName = (accountName) => {
      // Map common account names to translated versions (remove codes)
      const accountMappings = {
        // Common patterns with codes that need translation
        'Unsettled Dues (11200)': intl.formatMessage({ id: 'settlement_UnsettledDues' }),
        'Bank Account (10100)': intl.formatMessage({ id: 'settlement_BankAccountAssetName' }),
        'Commission Income (40100)': intl.formatMessage({ id: 'settlement_CommissionIncomeAccount' }),
        'VAT Payable (20300)': intl.formatMessage({ id: 'settlement_VATPayableAccount' }),
        'Operating Account (10100)': intl.formatMessage({ id: 'settlement_OperatingAccountName' }),
        'Fare Revenue (40100)': intl.formatMessage({ id: 'settlement_FareRevenueAccount' }),
        'Commission Expense (50100)': intl.formatMessage({ id: 'settlement_CommissionExpenseAccount' }),
        'VAT Receivable (10200)': intl.formatMessage({ id: 'settlement_VATReceivableAccount' }),
        // Also handle versions without codes
        'Unsettled Dues': intl.formatMessage({ id: 'settlement_UnsettledDues' }),
        'Bank Account': intl.formatMessage({ id: 'settlement_BankAccountAssetName' }),
        'Commission Income': intl.formatMessage({ id: 'settlement_CommissionIncomeAccount' }),
        'VAT Payable': intl.formatMessage({ id: 'settlement_VATPayableAccount' }),
        'Operating Account': intl.formatMessage({ id: 'settlement_OperatingAccountName' }),
        'Fare Revenue': intl.formatMessage({ id: 'settlement_FareRevenueAccount' }),
        'Commission Expense': intl.formatMessage({ id: 'settlement_CommissionExpenseAccount' }),
        'VAT Receivable': intl.formatMessage({ id: 'settlement_VATReceivableAccount' })
      };

      return accountMappings[accountName] || accountName;
    };
    const htmlContent = `
      <!DOCTYPE html>
      <html lang="en">
      <html>
      <head>
          <meta charset="UTF-8">
          <title>${intl.formatMessage({ id: 'settlement_SettlementReport' })} - ${data.id}</title>
          <style>
              * {
                  margin: 0;
                  padding: 0;
                  box-sizing: border-box;
              }
              
              body {
                  font-family: 'Arial', sans-serif;
                  line-height: 1.4;
                  color: #000;
                  background: #fff;
                  padding: 20px;
              }
              
              .container {
                  max-width: 800px;
                  margin: 0 auto;
                  padding: 20px;
                  background: white;
                  box-shadow: 0 0 10px rgba(0,0,0,0.1);
              }
              
              .header {
                  text-align: center;
                  border-bottom: 2px solid #000;
                  padding-bottom: 16px;
                  margin-bottom: 24px;
              }
              
              .header h1 {
                  color: #000;
                  font-size: 18px;
                  margin-bottom: 6px;
                  font-weight: 700;
              }
              
              .header .subtitle {
                  color: #000;
                  font-size: 12px;
              }
              
              .settlement-info {
                  display: grid;
                  grid-template-columns: 1fr 1fr;
                  gap: 16px;
                  margin-bottom: 20px;
              }
              
              .info-section {
                  background: #fff;
                  padding: 12px;
                  border-radius: 0;
                  border: 1px solid #000;
              }
              
              .info-section h3 {
                  color: #000;
                  margin-bottom: 8px;
                  font-size: 12px;
                  text-transform: uppercase;
                  letter-spacing: 0.5px;
                  font-weight: 500;
              }
              
              .info-row {
                  display: flex;
                  justify-content: space-between;
                  margin-bottom: 6px;
                  padding: 2px 0;
                  font-size: 11px;
              }
              
              .info-row:last-child {
                  margin-bottom: 0;
              }
              
              .info-label {
                  font-weight: 700;
                  color: #000;
                  font-size: 11px;
              }
              
              .info-value {
                  color: #000;
                  font-size: 11px;
              }
              
              .amount-highlight {
                  font-size: 11px;
                  font-weight: 700;
                  color: #000;
              }
              
              .journal-section {
                  margin: 20px 0;
              }
              
              .journal-section h3 {
                  color: #000;
                  margin-bottom: 10px;
                  font-size: 12px;
                  border-bottom: 1px solid #000;
                  padding-bottom: 6px;
                  text-transform: uppercase;
                  letter-spacing: 0.5px;
                  font-weight: 500;
              }
              
              .journal-table {
                  width: 100%;
                  border-collapse: collapse;
                  margin-bottom: 16px;
                  font-size: 11px;
              }
              
              .journal-table th,
              .journal-table td {
                  padding: 4px;
                  text-align: left;
                  border-bottom: 1px solid #000;
                  font-size: 11px;
              }
              
              .journal-table th {
                  background: #fff;
                  color: #000;
                  font-weight: 700;
                  border-top: 1px solid #000;
                  border-bottom: 2px solid #000;
                  font-size: 11px;
              }
              
              .amount-cell {
                  text-align: right;
                  font-weight: 700;
              }
              
              .total-row {
                  background: #fff !important;
                  font-weight: 700;
                  border-top: 2px solid #000;
              }
              
              .signature-section {
                  display: grid;
                  grid-template-columns: 1fr 1fr;
                  gap: 24px;
                  margin: 24px 0 16px 0;
              }
              
              .signature-box {
                  text-align: center;
                  padding: 16px;
                  border: 1px solid #000;
                  border-radius: 0;
                  font-size: 11px;
              }
              
              .footer {
                  margin-top: 24px;
                  padding-top: 12px;
                  border-top: 1px solid #000;
                  text-align: center;
                  color: #000;
                  font-size: 11px;
              }
              
              @media print {
                  * {
                      -webkit-print-color-adjust: exact !important;
                      print-color-adjust: exact !important;
                  }
                  
                  html, body {
                      margin: 0 !important;
                      padding: 0 !important;
                      width: 100% !important;
                      height: auto !important;
                      overflow: visible !important;
                  }
                  
                  body {
                      padding: 0;
                      font-size: 12px;
                  }
                  
                  .container {
                      max-width: none;
                      padding: 15px;
                      box-shadow: none;
                      margin: 0;
                      width: 100%;
                  }
                  
                  .action-buttons {
                      display: none !important;
                  }
                  
                  /* Prevent page breaks in critical sections */
                  .settlement-info,
                  .info-section,
                  .signature-section {
                      page-break-inside: avoid;
                      break-inside: avoid;
                  }
                  
                  /* Ensure tables don't break awkwardly */
                  .journal-table {
                      page-break-inside: avoid;
                      break-inside: avoid;
                  }
                  
                  .journal-table thead {
                      display: table-header-group;
                  }
                  
                  .journal-table tbody {
                      display: table-row-group;
                  }
                  
                  /* Page settings */
                  @page {
                      margin: 0.5in;
                      size: A4;
                  }
              }
          </style>
      </head>
      <body>
          <div class="container">
              <!-- Header -->
              <div class="header"style="margin-bottom:8px;">
                  <h1>${intl.formatMessage({ id: 'settlement_SettlementReport' })}</h1>
                  
                  <div class="subtitle"> ${data.id}</div>
                   
                          <!-- Created Date Section (for Confirmed, Cleared, Reversed statuses) -->
              ${['Confirmed', 'Cleared', 'Reversed'].includes(data.status) && data.created_at ? `
                 <div class="info-row"style="margin-bottom:-10px;text-align: center;display:flex;justify-content:center;">
                          <span class="info-label" style="text-align:center;">${intl.formatMessage({ id: 'settlement_CreatedAt' })}: ${formatDate(data.created_at)}</span>
                  </div>
              ` : ''}

               ${data.status !== 'Cleared' ? `
                          <div class="info-row"style="margin-top:-30px;">
                              <span class="info-label" style=" font-size: 12px;">${intl.formatMessage({ id: 'settlement_StatusLabel' })}: ${getTranslatedStatus(data.status)}</span>
                          </div>
                      ` : ''}
              <!-- Reversal Reason Section (for Reversed status) -->
              ${data.status === 'Reversed' && data.reversal_reason ? `<div >
                           <div class="info-row"style="margin:5px;">
                              <span class="info-label" style=" font-size: 12px;">${intl.formatMessage({ id: 'settlement_ReversalReason' })}: ${data.reversal_reason}</span>
                          </div>
                      ${data.reversed_at ? `
                              <div class="info-row"style="margin-bottom:-5px;">
                              <span class="info-label" style="font-size: 12px;">${intl.formatMessage({ id: 'settlement_ReversedAt' })}: ${formatDate(data.reversed_at)}</span>
                          </div>
                      ` : ''}
                  </div>
              ` : ''}


              </div>


          

              <!-- Period Section -->
              <div style="margin-bottom:5px;">
                  <span class="info-label">${intl.formatMessage({ id: 'settlement_From' })}:</span>
                  <span class="info-value">${data.fromDate || '-'}</span>
                  <span class="info-label">${intl.formatMessage({ id: 'settlement_To' })}:</span>
                  <span class="info-value">${data.toDate || '-'}</span>
              </div>

              <!-- Parties & Banks Section -->
              <div class="settlement-info" >
                  <div class="info-section">
                      <h3 >${intl.formatMessage({ id: 'settlement_SenderOurCompany' })}</h3>
                      <div class="info-row"style=" display: flex;justify-content: flex-start;">
                          <span class="info-label"style="display: block;
                width: 34%;">${intl.formatMessage({ id: 'settlement_Organisation' })}:</span>
                          <span class="info-value">${data.sender}</span>
                      </div>
                      <div class="info-row"style=" display: flex;justify-content: flex-start;">
                          <span class="info-label"style="display:block;width:34%;">${intl.formatMessage({ id: 'settlement_Bank' })}:</span>
                          <span class="info-value">${data.senderBankName || '-'}</span>
                      </div>
                      <div class="info-row"style=" display: flex;justify-content: flex-start;">
                          <span class="info-label"style="display:block;width:34%;">${intl.formatMessage({ id: 'settlement_BankAccount' })}:</span>
                          <span class="info-value">${data.senderBank}</span>
                      </div>
                  </div>

                  <div class="info-section">
                      <h3>${intl.formatMessage({ id: 'settlement_BeneficiaryPTO' })}</h3>
                      <div class="info-row"style=" display: flex;justify-content: flex-start;">
                          <span class="info-label"style="display:block;width:34%;">${intl.formatMessage({ id: 'settlement_Organisation' })}:</span>
                          <span class="info-value">${data.beneficiary}</span>
                      </div>
                      <div class="info-row"style=" display: flex;justify-content: flex-start;">
                          <span class="info-label"style="display:block;width:34%;">${intl.formatMessage({ id: 'settlement_Bank' })}:</span>
                          <span class="info-value">${data.beneficiaryBankName || '-'}</span>
                      </div>
                      <div class="info-row"style=" display: flex;justify-content: flex-start;">
                          <span class="info-label"style="display:block;width:34%;">${intl.formatMessage({ id: 'settlement_BankAccount' })}:</span>
                          <span class="info-value">${data.beneficiaryBank}</span>
                      </div>
                  </div>
              </div>

              <!-- Amount & Currency Section -->
              <div class="info-section" style="margin: 16px 0;">
                  <div class="info-row">
                      <strong>${intl.formatMessage({ id: 'settlement_AmountToSettleLabel' })}:</strong>
                      <span class="info-value amount-highlight">${formatAmount2(data.amount)} <span>${data.currency === 'EGP' ? intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : (data.currency || 'EGP')}</span></span>
                  </div>
              </div>

              <!-- Suggested ERP Journal Entries -->
              <div class="journal-section">
                  <!-- Sender Journal Entry -->
                  <div style="border: 1px solid #f0f0f0; border-radius: 4px; overflow: hidden; margin-bottom: 24px;">
                      <div style="background: #fafafa; padding: 12px 16px; border-bottom: 1px solid #f0f0f0; font-weight: 500; font-size: 11px;text-align: center;">
                          ${intl.formatMessage({ id: 'settlement_SuggestedERPJournalEntrySenderTitle' })}
                      </div>
                      <table class="journal-table" style="margin-bottom: 0;">
                          <thead>
                              <tr style="background: #fafafa;">
                                  <th style="flex: 3;">${intl.formatMessage({ id: 'settlement_Account' })}</th>
                                  <th style="flex: 1; text-align: center;">${intl.formatMessage({ id: 'settlement_Debit' })}</th>
                                  <th style="flex: 1; text-align: center;">${intl.formatMessage({ id: 'settlement_Credit' })}</th>
                                  <th style="flex: 2;">${intl.formatMessage({ id: 'settlement_DescriptionLabel' })}</th>
                              </tr>
                          </thead>
                          <tbody>
                              ${data.senderJournalEntries ? data.senderJournalEntries.map(entry => `
                                  <tr>
                                      <td>${getAccountName(entry.account)}</td>
                                      <td class="amount-cell">${entry.debit ? formatAmount5(entry.debit) + ' ' + intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : '-'}</td>
                                      <td class="amount-cell">${entry.credit ? formatAmount5(entry.credit) + ' ' + intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : '-'}</td>
                                      <td>${entry.description}</td>
                                  </tr>
                              `).join('') : ''}
                              <tr class="total-row">
                                  <td><strong>${intl.formatMessage({ id: 'settlement_Total' })}</strong></td>
                                  <td class="amount-cell">
                                      <strong>${data.senderJournalEntries ? formatAmount5(data.senderJournalEntries.reduce((sum, entry) => sum + (entry.debit || 0), 0)) : formatAmount5(0)} ${intl.formatMessage({ id: 'settlement_CurrencyEGP' })}</strong>
                                  </td>
                                  <td class="amount-cell">
                                      <strong>${data.senderJournalEntries ? formatAmount5(data.senderJournalEntries.reduce((sum, entry) => sum + (entry.credit || 0), 0)) : formatAmount5(0)} ${intl.formatMessage({ id: 'settlement_CurrencyEGP' })}</strong>
                                  </td>
                                  <td></td>
                              </tr>
                          </tbody>
                      </table>
                  </div>

                  <!-- Beneficiary Journal Entry -->
                  <div style="border: 1px solid #f0f0f0; border-radius: 4px; overflow: hidden;">
                      <div style="background: #fafafa; padding: 12px 16px; border-bottom: 1px solid #f0f0f0; font-weight: 500; font-size: 11px;text-align: center;">
                          ${intl.formatMessage({ id: 'settlement_SuggestedERPJournalEntryBeneficiaryTitle' })}
                      </div>
                      <table class="journal-table" style="margin-bottom: 0;">
                          <thead>
                              <tr style="background: #fafafa;">
                                  <th style="flex: 3;">${intl.formatMessage({ id: 'settlement_Account' })}</th>
                                  <th style="flex: 1; text-align: center;">${intl.formatMessage({ id: 'settlement_Debit' })}</th>
                                  <th style="flex: 1; text-align: center;">${intl.formatMessage({ id: 'settlement_Credit' })}</th>
                                  <th style="flex: 2;">${intl.formatMessage({ id: 'settlement_DescriptionLabel' })}</th>
                              </tr>
                          </thead>
                          <tbody>
                              ${data.beneficiaryJournalEntries ? data.beneficiaryJournalEntries.map(entry => `
                                  <tr>
                                      <td>${getAccountName(entry.account)}</td>
                                      <td class="amount-cell">${entry.debit ? formatAmount5(entry.debit) + ' ' + intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : '-'}</td>
                                      <td class="amount-cell">${entry.credit ? formatAmount5(entry.credit) + ' ' + intl.formatMessage({ id: 'settlement_CurrencyEGP' }) : '-'}</td>
                                      <td>${entry.description}</td>
                                  </tr>
                              `).join('') : ''}
                              <tr class="total-row">
                                  <td><strong>${intl.formatMessage({ id: 'settlement_Total' })}</strong></td>
                                  <td class="amount-cell">
                                      <strong>${data.beneficiaryJournalEntries ? formatAmount5(data.beneficiaryJournalEntries.reduce((sum, entry) => sum + (entry.debit || 0), 0)) : formatAmount5(0)} ${intl.formatMessage({ id: 'settlement_CurrencyEGP' })}</strong>
                                  </td>
                                  <td class="amount-cell">
                                      <strong>${data.beneficiaryJournalEntries ? formatAmount5(data.beneficiaryJournalEntries.reduce((sum, entry) => sum + (entry.credit || 0), 0)) : formatAmount5(0)} ${intl.formatMessage({ id: 'settlement_CurrencyEGP' })}</strong>
                                  </td>
                                  <td></td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>

              <!-- Bank Transfer Details -->
              <div class="info-section" style="margin: 16px 0;">
                  <h3>${intl.formatMessage({ id: 'settlement_BankTransferDetails' })}</h3>
                  ${(data.bank_ref_no || data.bank_description || data.bank_transfer_date) ? `
                      <div class="info-row">
                          <span class="info-label">${intl.formatMessage({ id: 'settlement_ACHReferenceNumber' })}:</span>
                          <span class="info-value">${data.bank_ref_no || '-'}</span>
                      </div>
                      <div class="info-row">
                          <span class="info-label">${intl.formatMessage({ id: 'settlement_Description' })}:</span>
                          <span class="info-value">${data.bank_description || '-'}</span>
                      </div>
                      <div class="info-row">
                          <span class="info-label">${intl.formatMessage({ id: 'settlement_TransferDateLabel' })}:</span>
                          <span class="info-value">${formatDate(data.bank_transfer_date)}</span>
                      </div>
                    
                  ` : `
                      <div class="info-row">
                          <span class="info-label" style="font-style: italic; color: #666;">${intl.formatMessage({ id: 'settlement_NoBankTransferDetailsEntered' })}</span>
                      </div>
                  `}
              </div>

              <!-- Bank Transfer Notes -->
              <div class="info-section" style="margin: 16px 0;">
                  <h3>${intl.formatMessage({ id: 'settlement_BankTransferNotes' })}</h3>
                  <div style="padding: 8px 0;font-size: 11px;">
                      ${data.notes || '<span class="info-label" style="font-size: 11px;font-style: italic; color: #666;">' + intl.formatMessage({ id: 'settlement_NoAdditionalNotes' }) + '</span>'}
                  </div>
              </div>

              <!-- Signature Section -->
              <div class="signature-section">
                  <div class="signature-box">
                      <strong>${intl.formatMessage({ id: 'settlement_FinanceManager' })}</strong><br>
                      <span style="font-size: 11px;">${intl.formatMessage({ id: 'settlement_NameLabel' })}: _____________________</span><br>
                      <span style="font-size: 11px;">${intl.formatMessage({ id: 'settlement_DateLabel' })}: _____________________</span><br>
                      <span style="font-size: 11px;">${intl.formatMessage({ id: 'settlement_Signature' })}: _________________</span>
                  </div>
                  <div class="signature-box">
                      <strong>${intl.formatMessage({ id: 'settlement_GeneralManager' })}</strong><br>
                      <span style="font-size: 11px;">${intl.formatMessage({ id: 'settlement_NameLabel' })}: _____________________</span><br>
                      <span style="font-size: 11px;">${intl.formatMessage({ id: 'settlement_DateLabel' })}: _____________________</span><br>
                      <span style="font-size: 11px;">${intl.formatMessage({ id: 'settlement_Signature' })}: _________________</span>
                  </div>
              </div>

              <!-- Footer -->
              <div class="footer">
                  <p><strong>${intl.formatMessage({ id: 'settlement_AFCSettlementSystem' })}</strong> | ${intl.formatMessage({ id: 'settlement_GeneratedOn' })} ${formatDate(new Date().toISOString())}</p>
              </div>
          </div>
      </body>
      </html>
    `;

    setHtmlContent(htmlContent);
  };

  const handlePrint = () => {
    if (!htmlContent) {
      message.error('No content available for printing');
      return;
    }

    // Create a new window with only the PDF content
    const printWindow = window.open('', '_blank', 'width=800,height=600');

    if (!printWindow) {
      message.error('Please allow popups to print the document');
      return;
    }

    // Write the HTML content to the new window
    printWindow.document.write(htmlContent);
    printWindow.document.close();

    // Wait for content to load, then print
    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();

        // Close the print window after printing
        setTimeout(() => {
          printWindow.close();
        }, 1000);
      }, 500);
    };

    // Fallback in case onload doesn't fire
    setTimeout(() => {
      if (printWindow && !printWindow.closed) {
        printWindow.focus();
        printWindow.print();

        setTimeout(() => {
          printWindow.close();
        }, 1000);
      }
    }, 1000);
  };

  const handleDownload = async () => {
    if (!settlementData) {
      message.error('No settlement data available for download');
      return;
    }

    console.log('Download button clicked, settlement data:', settlementData);

    try {
      // Use the new text-based PDF generation for selectable text
      console.log('Calling generateSettlementPDF...');
      await generateSettlementPDF(settlementData, intl);
      message.success('PDF downloaded successfully with selectable text');
    } catch (error) {
      console.error('Error downloading PDF:', error);

      // Fallback to HTML-based generation if jsPDF fails
      try {
        console.log('Falling back to HTML-based PDF generation...');
        const opt = {
          margin: 0.4,
          filename: `settlement-${settlementData.id}.pdf`,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
        };

        await html2pdf().set(opt).from(htmlContent).save();
        message.warning('PDF downloaded using fallback method (text may not be selectable)');
      } catch (fallbackError) {
        console.error('Fallback PDF generation also failed:', fallbackError);
        message.error('Failed to download PDF');
      }
    }
  };

  const handleDownloadTextPDF = async () => {
    if (!settlementData) {
      message.error('No settlement data available for download');
      return;
    }

    console.log('Text PDF download button clicked, settlement data:', settlementData);

    try {
      console.log('Calling generateSettlementTextPDF...');

      // Check if the function exists
      if (typeof generateSettlementTextPDF !== 'function') {
        throw new Error('generateSettlementTextPDF is not a function');
      }

      // Detect if Arabic language is being used
      const isArabic = intl && intl.locale && intl.locale.includes('ar');

      await generateSettlementTextPDF(settlementData, intl);

      if (isArabic) {
        message.success('PDF downloaded successfully with Arabic support! (Note: Arabic PDFs use HTML-based generation for proper text rendering)');
      } else {
        message.success('Text-based PDF downloaded successfully! Text can be copied and selected.');
      }
    } catch (error) {
      console.error('Error downloading text-based PDF:', error);
      console.error('Error details:', error.message, error.stack);
      message.error(`Failed to download text-based PDF: ${error.message}`);
    }
  };


  if (!settlementData) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        gap: '16px'
      }}>
        <div>Loading settlement data...</div>
        <div style={{ fontSize: '14px', color: '#666' }}>
          If this takes too long, please check the browser console for errors.
        </div>
      </div>
    );
  }

  return (
    <div className="pdf-preview-container">
      {/* PDF Content */}
      <div
        className="pdf-content"
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />

      {/* Fixed Action Buttons */}
      <div className="action-buttons">
        <Button
          type="primary"

          onClick={handlePrint}
          size="large"
          className="action-btn print-btn"
        >
          {intl.formatMessage({ id: 'settlement_Print' })}
        </Button>

        <Button
          type="default"

          onClick={handleDownloadTextPDF}
          size="large"
          className="action-btn download-text-btn"
          style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', color: 'white' }}
        >
          {intl.formatMessage({ id: 'settlement_Download' })}
        </Button>

        {/*<Button
          type="default"
          icon={<DownloadOutlined />}
          onClick={handleDownload}
          size="large"
          className="action-btn download-btn"
        >
          {intl.formatMessage({ id: 'settlement_Download' })}
        </Button>*/}
      </div>
    </div>
  );
};

export default PDFPreview;
